import {BaseModel} from "../../../../infrastructure/models/base-model";
import {EntityDomainModel} from "../../../../infrastructure/models/entity/entity.domain-model";
import {EntityViewModel} from "../../../../infrastructure/models/entity/entity.view-model";
import {BaseLinkModel} from "../../../../infrastructure/models/link/base-link-model";
import {WebsiteModuleConfig} from "../../../../apps/website/website-module.config";

export class DescriptionHeaderViewModel extends BaseModel {
  entity: EntityDomainModel;
  title: String;
  description: String;

  constructor(
    entity: EntityDomainModel,
    title: String,
    description: String,
    config: WebsiteModuleConfig
  ) {
    super();

    this.entity = entity;
    this.title = title;
    this.description = description;
    this.config = config;
  }

  get id(): Number {
    return console.error(this.constructor.name + 'Implementation is missing: id');
  }

  get color(): String {
    return console.error(this.constructor.name + 'Implementation is missing: color');
  }

  get textureId(): Number {
    return console.error(this.constructor.name + 'Implementation is missing: textureId');
  }

  get objectType(): EntityViewModel {
    return console.error(this.constructor.name + 'Implementation is missing: objectType');
  }

  get popularityRank(): EntityViewModel {
    return console.error(this.constructor.name + 'Implementation is missing: popularityRank');
  }

  get extraIds() {
    return console.error(this.constructor.name + 'Implementation is missing: extraIds');
  }

  get shouldRenderPopularityRank(): Boolean {
    return console.error(this.constructor.name + 'Implementation is missing: shouldRenderPopularityRank');
  }

  get useLink(): Boolean {
    return false;
  }

  get linkModel(): BaseLinkModel {
    return null;
  }
}